import { sleep } from './common';

export interface PerformWithRetriesOptions {
  retryCount?: number;
  retryDelayMs?: number;
  exponentialBackoff?: boolean;
  currentAttempt?: number;
}

export const performWithRetries = async <T>(
  functionToExecute: () => Promise<T>,
  options: PerformWithRetriesOptions = {},
): Promise<T> => {
  const {
    retryCount = 3,
    retryDelayMs = 1000,
    exponentialBackoff = false,
    currentAttempt = 0,
  } = options;
  try {
    const result = await functionToExecute();
    return result;
  } catch (e) {
    const newRetryCount = retryCount - 1;
    if (newRetryCount <= 0) {
      throw e;
    }

    const delay = exponentialBackoff
      ? retryDelayMs * Math.pow(2, currentAttempt)
      : retryDelayMs;

    await sleep(delay);
    return performWithRetries(functionToExecute, {
      retryCount: newRetryCount,
      retryDelayMs,
      exponentialBackoff,
      currentAttempt: currentAttempt + 1,
    });
  }
};
